import { Injectable, signal } from '@angular/core';
import { DeliveryTrackerEmailFilterStore } from '@features/organization/components/delivery-tracker-detail/stores/delivery-tracker-email-filter.store';
import type { UUID } from '@kerberos-compliance/compliance-shared-ts/common/types/uuid.type';
import type { EmailType } from '@kerberos-compliance/compliance-shared-ts/features/notification/enums/email-type.enum';
import { OrganizationEmailTypeMap } from '@kerberos-compliance/compliance-shared-ts/features/notification/enums/email-type.enum';

@Injectable()
export class OrganizationEmailListFilterStore extends DeliveryTrackerEmailFilterStore {
  protected override readonly emailTypes: EmailType[] = Object.values(OrganizationEmailTypeMap);

  private readonly organizationIdSignal = signal<UUID | undefined>(undefined);

  public readonly organizationId = this.organizationIdSignal.asReadonly();

  public setOrganizationId(id: UUID): void {
    this.organizationIdSignal.set(id);
  }
}
